export const appHead = {"meta":[{"name":"viewport","content":"width=device-width, initial-scale=1"},{"charset":"utf-8"}],"link":[{"href":"https://fonts.googleapis.com/css2?family=Poppins:wght@400;500;700&display=swap","rel":"stylesheet"},{"href":"/manifest.json","rel":"manifest"}],"style":[],"script":[{"src":"https://kit.fontawesome.com/f6e4df848a.js","crossorigin":"anonymous"},{"src":"https://js.stripe.com/v3/","defer":"defer"},{"src":"https://www.google.com/recaptcha/api.js?render=6LeNqfAUAAAAAB7xA8LghLiZQDJ0Wddlw0OTwZQ1","async":true},{"src":"https://reports.heymarv.com/app/iframeResizer.js","defer":"defer"},{"innerHTML":"\n      !(function (f, b, e, v, n, t, s) {\n        if (f.fbq) return;\n        n = f.fbq = function () {\n          n.callMethod\n            ? n.callMethod.apply(n, arguments)\n            : n.queue.push(arguments);\n        };\n        if (!f._fbq) f._fbq = n;\n        n.push = n;\n        n.loaded = !0;\n        n.version = '2.0';\n        n.queue = [];\n        t = b.createElement(e);\n        t.async = !0;\n        t.src = v;\n        s = b.getElementsByTagName(e)[0];\n        s.parentNode.insertBefore(t, s);\n      })(\n        window,\n        document,\n        'script',\n        'https://connect.facebook.net/en_US/fbevents.js'\n      );\n      window.fbq.disablePushState = true;\n    "},{"innerHTML":"\n      (function (w, d, s, l, i) {\n        w[l] = w[l] || [];\n        w[l].push({ 'gtm.start': new Date().getTime(), event: 'gtm.js' });\n        var f = d.getElementsByTagName(s)[0],\n          j = d.createElement(s),\n          dl = l != 'dataLayer' ? '&l=' + l : '';\n        j.async = true;\n        j.src = 'https://www.googletagmanager.com/gtm.js?id=' + i + dl;\n        f.parentNode.insertBefore(j, f);\n      })(window, document, 'script', 'dataLayer', 'GTM-TWZ87PK');\n      function gtag() {\n        dataLayer.push(arguments);\n      }\n    "},{"src":"https://assets.calendly.com/assets/external/widget.js","defer":"defer"},{"src":"https://kit.fontawesome.com/f6e4df848a.js","crossorigin":"anonymous"},{"src":"https://sdk.canva.com/designbutton/v2/api.js","defer":"defer"},{"innerHTML":"\n      try {\n        if ('serviceWorker' in navigator) {\n          navigator.serviceWorker.register('/sw.js');\n        }\n      } catch (e) {\n        console.log('Service worker registration failed:', e);\n      }\n    "}],"noscript":[]}

export const appBaseURL = "/"

export const appBuildAssetsDir = "/_nuxt/"

export const appCdnURL = ""

export const appLayoutTransition = false

export const appPageTransition = false

export const appViewTransition = false

export const appKeepalive = false

export const appRootId = "__nuxt"

export const appRootTag = "div"

export const appTeleportTag = "div"

export const appTeleportId = "teleports"

export const renderJsonPayloads = true

export const componentIslands = false

export const payloadExtraction = true

export const cookieStore = false

export const appManifest = true

export const remoteComponentIslands = false

export const selectiveClient = false

export const devPagesDir = null

export const devRootDir = null

export const devLogs = false

export const nuxtLinkDefaults = {"componentName":"NuxtLink"}

export const asyncDataDefaults = {"deep":true}

export const fetchDefaults = {}

export const vueAppRootContainer = '#__nuxt'

export const viewTransition = false